import { render, staticRenderFns } from "./DetalleAlojamiento.vue?vue&type=template&id=6d4bb792&scoped=true&"
import script from "./DetalleAlojamiento.vue?vue&type=script&lang=js&"
export * from "./DetalleAlojamiento.vue?vue&type=script&lang=js&"
import style0 from "./DetalleAlojamiento.vue?vue&type=style&index=0&id=6d4bb792&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4bb792",
  null
  
)

export default component.exports